import {BaseConfig} from "../../infrastructure/config/base-config";
import {StandingsWidgetTerms} from "./standings-widget.terms";

export class StandingsWidgetConfig extends BaseConfig {

  static injectables = [StandingsWidgetTerms];

  constructor(terms: StandingsWidgetTerms) {
    super('standingWidget', null, terms);
  }
}
